import { Body } from "./components/body/body";
import { Header } from "./components/header/header";
import { Base } from "./infoCard.base";

export const InfoCard = Object.assign(Base, {
    Header: Header,
    Body: Body
});
